export const getAccountId = (): string | null => window.MEDIAHUIS?.user?.accountId
export const getAuth0Feature = (): boolean => Boolean(window.MEDIAHUIS?.config?.features?.auth0)
export const userIsNotLoggedIn = (): boolean => Boolean(!window.MEDIAHUIS?.user?.isLoggedIn)

export const checkIfClassNameIncludesSubstring = (dialogItem: any, substring: string): boolean => {
  let result = false
  const classList = dialogItem.classList

  for (let j = 0; j < classList.length; j++) {
    if (classList[j].includes(substring)) {
      result = true
    }
  }
  return result
}

export const checkIfDialogInShadowDomIsVisible = (shadowDomDialogList: any): boolean => {
  for (let i = 0; i < shadowDomDialogList.length; i++) {
    if (shadowDomDialogList[i].shadowRoot) {
      if (shadowDomDialogList[i].shadowRoot?.mode.includes('open')) {
        return false
      }
    }
  }
  return true
}

export const isOnlyVisibleDialog = (): boolean => {
  const dialogList = document.querySelectorAll('div[role=dialog]')

  for (let i = 0; i < dialogList.length; i++) {
    const dialogVisibility = window.getComputedStyle(dialogList[i]).visibility

    if (dialogVisibility === 'visible') {
      if (!checkIfClassNameIncludesSubstring(dialogList[i], 'hidden')) {
        return false
      }
    }
  }
  const shadowDomDialogList = document.querySelectorAll('getsitecontrol-widget')
  if (!checkIfDialogInShadowDomIsVisible(shadowDomDialogList)) return false

  return true
}

export const isNotMobile = (): boolean => {
  if (window.location.href.includes('origin=app')) return false
  return true
}
